<template>
  <div id="TopicEdit_main">
    <el-table
      :data="data"
      label-position="left"
      label-width="80px"
      :header-cell-class-name="cellStyle"
    >
      <el-table-column
        type="index"
        align="left"
        min-width="10"
      />
      <el-table-column label="議案標題">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.title"
            :rows="3"
            :class="scope.row.error.isTitleError ? 'titleTextarea' : ''"
            type="textarea"
            :placeholder="errorMsg.TOPIC_TITLE"
            maxlength="100"
            show-word-limit
            @change="titleTextareaChange(scope.$index)"
          />
          <span
            v-if="scope.row.error.isTitleError"
            class="titleError"
          >{{ errorMsg.TOPIC_TITLE }}</span>
        </template>
      </el-table-column>
      <el-table-column label="議案說明">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.description"
            :rows="3"
            type="textarea"
            placeholder="請輸入議案說明"
            maxlength="300"
            show-word-limit
          />
        </template>
      </el-table-column>
      <el-table-column
        label="出席標準"
        min-width="30"
      >
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.attendanceThreshold"
            :precision="2"
            :step="1"
            :min="1"
            :max="100"
            :class="{'attendanceErrorBorder': scope.row.error.isAttendanceThresholdError}"
            @change="changeThreshold(scope.$index)"
          />
          <span class="num">％</span>
          <p
            v-if="scope.row.error.isAttendanceThresholdError"
            class="attendanceError"
          >
            {{ errorMsg.ATTENDANCE_THRESHOLD_SHORT }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="投票標準"
        min-width="30"
      >
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.consentThreshold"
            :precision="2"
            :step="1"
            :min="1"
            :max="100"
            @change="changeThreshold(scope.$index)"
          />
          <span class="num">％</span>
        </template>
      </el-table-column>
      <el-table-column
        label="移除"
        min-width="12"
      >
        <template slot-scope="scope">
          <i
            class="icon-trashcan"
            aria-hidden="true"
            @click="removeRow(scope.$index)"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-button
      icon="icon-plus"
      :disabled="addRowDisabled"
      round
      @click="addRow"
    >
      新增議案
    </el-button>
    <p
      v-if="addRowDisabled"
      class="tip"
    >
      議案最多可新增 20 個
    </p>
  </div>
</template>
<script>
export default {
  props: {
    // 會議出席門檻
    mainThreshold: Number
  },
  data () {
    const defaultThreshold = 50
    const mainThreshold = this.mainThreshold || defaultThreshold
    return {
      errorMsg: {
        TOPIC_TITLE: '請輸入議案標題',
        ATTENDANCE_THRESHOLD: '出席標準應 ≥ 報到統計規則',
        ATTENDANCE_THRESHOLD_SHORT: '應 ≥ 報到統計規則'
      },
      defaultRatio: mainThreshold,
      addRowDisabled: false, // 禁用新增按鈕
      defaultAttendanceThreshold: mainThreshold, // 預設出席門檻，應為會議出席門檻
      defaultConsentThreshold: defaultThreshold, // 預設投票門檻，均設置為 50
      data: [
        {
          title: '',
          error: {
            isTitleError: false,
            isAttendanceThresholdError: false
          },
          description: '',
          attendanceThreshold: mainThreshold,
          consentThreshold: defaultThreshold
        }
      ]
    }
  },
  watch: {
    mainThreshold: function (nV) {
      // 當會議出席門檻改變，議案預設的出席門檻也將改變
      this.defaultAttendanceThreshold = nV
    }
  },
  methods: {
    // 編輯會議時，顯示已儲存資料
    show (data) {
      this.data = []
      data.forEach(item => {
        this.data.push({
          title: item.title,
          error: {
            isTitleError: false,
            isAttendanceThresholdError: false
          },
          description: item.description,
          attendanceThreshold: item.attendanceThreshold * 100,
          consentThreshold: item.consentThreshold * 100
        })
      })
    },
    // 編輯會議時，送出更新議案
    updateTopicList () {
      const data = JSON.parse(JSON.stringify(this.data))
      data.forEach(item => {
        item.attendanceThreshold = item.attendanceThreshold / 100
        item.consentThreshold = item.consentThreshold / 100
        delete item.error
      })
      return apiUnitOwnerAssembly.Topic.InsertTopics(
        {
          assemblyId: this.$route.query.id,
          topicDtos: data
        }
      )
    },
    // 新增議案
    addRow () {
      if (this.data.length < 20) {
        if (this.data.length > 0) {
          // 新增議案時，如果有上一個議案，而上一個議案的出席標準比 main-threshold 還大則預設改為上一個的值，否則使用 main-threshold
          if (this.data[this.data.length - 1].attendanceThreshold > this.mainThreshold) {
            this.defaultAttendanceThreshold = this.data[this.data.length - 1].attendanceThreshold
          } else {
            this.defaultAttendanceThreshold = this.mainThreshold
          }
          this.defaultConsentThreshold = this.data[this.data.length - 1].consentThreshold
        }
        this.data.push(
          {
            title: '',
            error: {
              isTitleError: false,
              isAttendanceThresholdError: false
            },
            description: '',
            attendanceThreshold: this.defaultAttendanceThreshold,
            consentThreshold: this.defaultConsentThreshold
          }
        )
        this.addRowDisabled = this.data.length >= 20
      }
    },
    // 移除議案
    removeRow (index) {
      this.data.splice(index, 1)
      this.addRowDisabled = this.data.length >= 20
    },
    // 百分比欄位不可為空，不可小於 mainThreshold
    changeThreshold (index) {
      // eslint-disable-next-line eqeqeq
      if (this.data[index].attendanceThreshold == undefined) {
        this.$nextTick(() => {
          this.data[index].attendanceThreshold = this.defaultAttendanceThreshold
        })
      } else {
        this.data[index].error.isAttendanceThresholdError = this.data[index].attendanceThreshold < this.mainThreshold
      }
      // eslint-disable-next-line eqeqeq
      if (this.data[index].consentThreshold == undefined) {
        this.$nextTick(() => {
          this.data[index].consentThreshold = this.defaultConsentThreshold
        })
      }
    },
    // 確認必填，僅確認議案標題欄位
    syncCheckRule () {
      let invalidMsg = ''
      // 標示出所有警告
      this.data.forEach((item, index) => {
        console.log(item)
        if (item.title === '') {
          // 如果沒有警告資訊才更新警告資訊，欲警告最先出現的
          if (invalidMsg === '') invalidMsg = this.errorMsg.TOPIC_TITLE
          this.data[index].error.isTitleError = true
        }
        if (item.attendanceThreshold < this.mainThreshold) {
          if (invalidMsg === '') invalidMsg = this.errorMsg.ATTENDANCE_THRESHOLD
          this.data[index].error.isAttendanceThresholdError = true
        }
      })
      return invalidMsg
    },
    // 輸出建立會議時議案string
    getTopicString () {
      return new Promise((resolve, reject) => {
        const data = JSON.parse(JSON.stringify(this.data))
        data.forEach(item => {
          item.attendanceThreshold = item.attendanceThreshold / 100
          item.consentThreshold = item.consentThreshold / 100
          delete item.error
        })
        resolve(JSON.stringify(data))
      })
    },
    titleTextareaChange (index) {
      this.data[index].error.isTitleError = this.data[index].title === ''
    },
    attendanceThresholdChange (index) {
      this.data[index].attendanceError = this.data[index].attendanceThreshold < this.mainThreshold
    },
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) { return 'redStar' }
    }
  }
}
</script>
<style lang="sass" scoped>
#TopicEdit_main
  ::v-deep .el-table
    +basicTable
    .redStar
      .cell
        +redStar
        &::before
          left: 0px
    .el-table__body
      tr td
        padding: 25px 0
      tr:hover,tr.hover-row
        > td
          background-color: $white
          &:first-child
            border-left: 0px
      .el-textarea.titleTextarea
        .el-textarea__inner
          border-color: $dangerColor
      .attendanceErrorBorder
        input
          border-color: $dangerColor
      .titleError, .attendanceError
        color: $dangerColor
        font-size: 12px
        position: absolute
        bottom: 0
        left: 10px
      .attendanceError
        bottom: 20px
      .icon-trashcan
        color: $dangerColor
        font-size: 25px
        cursor: pointer
    .el-input-number
      width: 80px
      .el-input-number__decrease,.el-input-number__increase
        display: none
      .el-input
        .el-input__inner
          font-weight: bold
          font-size: 18px
          letter-spacing: 2px
          padding-right: 0
          padding-left: 0
    .num
      margin-left: 5px
  .el-button
    margin: 20px
  .tip
    position: relative
    top: -45px
    left: 150px
    color: $subFontColor
    font-size: 14px
</style>
